/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Uint64; });
var Uint64 = /** @class */ (function () {
    function Uint64(high, low) {
        this.high = high;
        this.low = low;
    }
    Uint64.prototype.add = function (other) {
        var low = this.low + other.low;
        var carry = this.low > 0x100000000 ? 1 : 0;
        this.low = low >>> 0;
        this.high = (this.high + other.high + carry) >>> 0;
        return this;
    };
    Uint64.prototype.mul = function (other) {
        var a0 = this.low & 0xffff;
        var a1 = this.low >>> 16;
        var b0 = other.low & 0xffff;
        var b1 = other.low >>> 16;
        this.high = (((a1 * b0 + a0 * b1 + (a0 * b0 >>> 16)) >>> 16) + a1 * b1 + Math.imul(this.low, other.high) + Math.imul(other.low, this.high)) >>> 0;
        this.low = Math.imul(this.low, other.low);
        return this;
    };
    return Uint64;
}());



/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(6);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RATIO; });
var RATIO = 0.25;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(4);
module.exports = __webpack_require__(11);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(5).enable();
  window.Promise = __webpack_require__(8);
}

// fetch() polyfill for making API calls.
__webpack_require__(9);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(10);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(1);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(1);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__registerServiceWorker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfill_AudioContext__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfill_AudioContext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__polyfill_AudioContext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__audio_visualize__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rng_search__ = __webpack_require__(17);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// import * as React from 'react';
// import * as ReactDOM from 'react-dom';
// import App from './App';





function main() {
    return __awaiter(this, void 0, void 0, function () {
        var stream, ctx, source, analyser, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    document.getElementById('form').addEventListener('submit', function (e) {
                        var results = Object(__WEBPACK_IMPORTED_MODULE_4__rng_search__["c" /* search */])();
                        var outputTextarea = document.getElementById('output');
                        if (results.length > 0) {
                            outputTextarea.value = results.join('\n');
                        }
                        else {
                            outputTextarea.value = 'not found';
                        }
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_4__rng_search__["e" /* setupNowTimeButton */])();
                    Object(__WEBPACK_IMPORTED_MODULE_4__rng_search__["d" /* setupFormSegments */])();
                    document.getElementById('save-button').addEventListener('click', function (e) {
                        Object(__WEBPACK_IMPORTED_MODULE_4__rng_search__["b" /* save5genParams */])();
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_4__rng_search__["a" /* load5genParams */])();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ audio: true })];
                case 2:
                    stream = _a.sent();
                    ctx = new AudioContext();
                    source = ctx.createMediaStreamSource(stream);
                    analyser = ctx.createAnalyser();
                    // analyser.minDecibels = -90;
                    analyser.maxDecibels = -40;
                    // analyser.smoothingTimeConstant = 0.85;
                    source.connect(analyser);
                    Object(__WEBPACK_IMPORTED_MODULE_3__audio_visualize__["a" /* visualize */])(analyser, ctx); // 音声の解析
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    alert(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
main();
// ReactDOM.render(
//   <App />,
//   document.getElementById('root') as HTMLElement
// );
Object(__WEBPACK_IMPORTED_MODULE_0__registerServiceWorker__["a" /* default */])();


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// tslint:disable:no-console
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the 'N+1' visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register() {
    if ("production" === 'production' && 'serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        var publicUrl = new URL("", window.location.toString());
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
            return;
        }
        window.addEventListener('load', function () {
            var swUrl = "" + "/service-worker.js";
            if (!isLocalhost) {
                // Is not local host. Just register service worker
                registerValidSW(swUrl);
            }
            else {
                // This is running on localhost. Lets check if a service worker still exists or not.
                checkValidServiceWorker(swUrl);
            }
        });
    }
}
function registerValidSW(swUrl) {
    navigator.serviceWorker
        .register(swUrl)
        .then(function (registration) {
        registration.onupdatefound = function () {
            var installingWorker = registration.installing;
            if (installingWorker) {
                installingWorker.onstatechange = function () {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            // At this point, the old content will have been purged and
                            // the fresh content will have been added to the cache.
                            // It's the perfect time to display a 'New content is
                            // available; please refresh.' message in your web app.
                            console.log('New content is available; please refresh.');
                        }
                        else {
                            // At this point, everything has been precached.
                            // It's the perfect time to display a
                            // 'Content is cached for offline use.' message.
                            console.log('Content is cached for offline use.');
                        }
                    }
                };
            }
        };
    })
        .catch(function (error) {
        console.error('Error during service worker registration:', error);
    });
}
function checkValidServiceWorker(swUrl) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl)
        .then(function (response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        if (response.status === 404 ||
            response.headers.get('content-type').indexOf('javascript') === -1) {
            // No service worker found. Probably a different app. Reload the page.
            navigator.serviceWorker.ready.then(function (registration) {
                registration.unregister().then(function () {
                    window.location.reload();
                });
            });
        }
        else {
            // Service worker found. Proceed as normal.
            registerValidSW(swUrl);
        }
    })
        .catch(function () {
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(function (registration) {
            registration.unregister();
        });
    }
}


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// Safari のための Polyfill
window.AudioContext = window.AudioContext || window.webkitAudioContext;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = visualize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMaxFftSize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(2);


function retrieveBig(data) {
    var length = data.length;
    var res = [];
    for (var i = 0; i < length; i++) {
        if (data[i] > 250) {
            if (res.length > 0 && res[res.length - 1][1] === i - 1) {
                var _a = res[res.length - 1], start = _a[0], repr = _a[2], max = _a[3];
                if (data[i] > max) {
                    max = data[i];
                    repr = i;
                }
                res[res.length - 1] = [start, i, repr, max];
            }
            else {
                res.push([i, i, i, data[i]]);
            }
        }
    }
    return res.map(function (tuple) {
        var repr = tuple[2];
        return repr;
    });
}
function setupCanvas() {
    var canvas = document.createElement('canvas');
    document.body.appendChild(canvas);
    canvas.width = 1000;
    canvas.height = 500;
    return canvas;
}
function updateCanvas(canvas, dataArray, freqUnit) {
    var canvasCtx = canvas.getContext('2d');
    var WIDTH = canvas.width;
    var HEIGHT = canvas.height;
    var bufferLength = dataArray.length;
    if (!canvasCtx) {
        return;
    }
    canvasCtx.drawImage(canvas, 1, 0, WIDTH - 1, HEIGHT, 0, 0, WIDTH - 1, HEIGHT);
    for (var i = 0; i < bufferLength; i++) {
        var mag = dataArray[i];
        if (mag > 250) {
            canvasCtx.fillStyle = 'white';
        }
        else {
            canvasCtx.fillStyle = 'hsl(' + ((1 - mag / 256) * 240) + ',50%,50%)';
        }
        canvasCtx.fillRect(WIDTH - 1, (1 - i / bufferLength) * HEIGHT, WIDTH, (1 - (i + 1) / bufferLength) * HEIGHT);
    }
}
function visualize(analyser, ctx) {
    var canvas = setupCanvas();
    analyser.fftSize = Math.min(32768, Object(__WEBPACK_IMPORTED_MODULE_0__getMaxFftSize__["a" /* getMaxFftSize */])());
    var bufferLength = 2000 * analyser.fftSize / ctx.sampleRate; // analyser.frequencyBinCount;
    var dataArray = new Uint8Array(bufferLength);
    var contiguousBigPoints = [];
    var drawAlt = function () {
        requestAnimationFrame(drawAlt);
        var MIN_FREQ = Number(document.getElementById('freq').value);
        var MAX_FREQ = (__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* RATIO */] + 1) * MIN_FREQ;
        var maxDecibels = Number(document.getElementById('maxDecibels').value);
        if (-100 < maxDecibels && maxDecibels <= 0) {
            analyser.maxDecibels = maxDecibels;
        }
        analyser.getByteFrequencyData(dataArray);
        var bigPoints = retrieveBig(dataArray);
        var seen = new Set();
        for (var _i = 0, bigPoints_1 = bigPoints; _i < bigPoints_1.length; _i++) {
            var pt = bigPoints_1[_i];
            var set = false;
            for (var i = 0; i < contiguousBigPoints.length; i++) {
                var _a = contiguousBigPoints[i], pt2 = _a[0], count = _a[1];
                if (Math.abs(pt - pt2) <= 2) {
                    contiguousBigPoints[i] = [pt, count + 1];
                    set = true;
                }
            }
            if (!set) {
                contiguousBigPoints.push([pt, 1]);
            }
            seen.add(pt);
        }
        var newCbp = [];
        var chatotGrowling = false;
        var addedPt = null;
        contiguousBigPoints.forEach(function (_a) {
            var pt = _a[0], count = _a[1];
            var freq = pt * ctx.sampleRate / analyser.fftSize;
            var isChatot = MIN_FREQ - 2 <= freq && freq < MAX_FREQ + 2;
            if (seen.has(pt)) {
                newCbp.push([pt, count]);
                if (isChatot) {
                    chatotGrowling = true;
                }
            }
            else {
                if (count >= 10 && isChatot) {
                    addedPt = pt;
                }
            }
        });
        contiguousBigPoints = newCbp;
        var freqUnit = ctx.sampleRate / analyser.fftSize;
        var max = 0;
        var maxFreq = 0;
        for (var i = 0; i < bufferLength; i++) {
            var mag = dataArray[i];
            if (max < mag) {
                max = mag;
                maxFreq = i * freqUnit;
            }
        }
        var paragraph = document.getElementById('maxHz');
        paragraph.innerText = '♪ ' + String(Math.round(maxFreq)) + 'Hz';
        paragraph.style.backgroundColor = chatotGrowling ? '#f9c94f' : 'white';
        if (addedPt) {
            var textarea = document.getElementById('input');
            if (textarea.value !== '') {
                textarea.value += '\n';
            }
            textarea.value += Math.round(addedPt * freqUnit);
        }
        updateCanvas(canvas, dataArray, freqUnit);
    };
    drawAlt();
}


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMaxFftSize; });
/*
 * 動作環境における fftSize の最大値を返す
 */
var getMaxFftSize = function () {
    var audioCtx = new AudioContext();
    var analyser = audioCtx.createAnalyser();
    analyser.fftSize = 2048; // default fftSize
    try {
        while (true) {
            analyser.fftSize *= 2;
        }
    }
    catch (_a) {
        var max = analyser.fftSize;
        audioCtx.close();
        return max;
        // nothing
    }
};


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = search;
/* harmony export (immutable) */ __webpack_exports__["d"] = setupFormSegments;
/* harmony export (immutable) */ __webpack_exports__["e"] = setupNowTimeButton;
/* harmony export (immutable) */ __webpack_exports__["b"] = save5genParams;
/* harmony export (immutable) */ __webpack_exports__["a"] = load5genParams;
/* unused harmony export searchIseedForGen4 */
/* unused harmony export searchSeedForGen4 */
/* unused harmony export searchfrmForGen4 */
/* unused harmony export searchfrmForGen5 */
/* unused harmony export searchIseedForGen5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lcg__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audio_constant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uint64__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gen5_seed__ = __webpack_require__(20);





function search() {
    var minFreq = Number(document.getElementById('freq').value);
    // mode
    var form = document.getElementById('form');
    var mode = selectedMode();
    // 4gen 初期seed検索
    var upper = Number(form['upper-4gen-iseed'].value) || 0;
    var upperErr = Number(form['upper-err-4gen-iseed'].value) || 0;
    var hour = Number(form['hour-4gen-iseed'].value) || 0;
    var minFrame4genIseed = Number(form['min-frame-4gen-iseed'].value) || 0;
    var maxFrame4genIseed = Number(form['max-frame-4gen-iseed'].value) || 0;
    var frm4genIseed = Number(form['frm-4gen-iseed'].value) || 0;
    // 4gen 消費数検索
    var seed4gen = Number(form['seed-4gen'].value) || 0;
    var frm4gen = Number(form['frm-4gen'].value) || 0;
    // 5gen 消費数検索
    var seed5gen = form['seed-5gen'].value.match(/^0x/) ? Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* parseUint64 */])(form['seed-5gen'].value.slice(2)) : new __WEBPACK_IMPORTED_MODULE_3__uint64__["a" /* Uint64 */](0, 0);
    var frm5gen = Number(form['frm-5gen'].value) || 0;
    // 5gen 初期seed検索
    var nazo1 = Number(form.nazo1.value) || 0;
    var nazo2 = Number(form.nazo2.value) || 0;
    var nazo3 = Number(form.nazo3.value) || 0;
    var nazo4 = Number(form.nazo4.value) || 0;
    var nazo5 = Number(form.nazo5.value) || 0;
    var vcount = Number(form.vcount.value) || 0;
    var gxstat = Number(form.gxstat.value) || 0;
    var frame = Number(form.frame.value) || 0;
    var timer0Min = Number(form['timer0-min'].value) || 0;
    var timer0Max = Number(form['timer0-max'].value) || 0;
    var matched = form.macaddr.value.match(/^([0-9a-f]{2})-([0-9a-f]{2})-([0-9a-f]{2})-([0-9a-f]{2})-([0-9a-f]{2})-([0-9a-f]{2})$/i);
    var macAddr = matched ? matched.slice(1, 7).map(function (x) { return parseInt(x, 16); }) : [0, 0, 0, 0, 0, 0];
    var matched2 = form.time.value.match(/([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})/);
    var time;
    if (matched2) {
        time = new Date(Number(matched2[1]), Number(matched2[2]) - 1, Number(matched2[3]), Number(matched2[4]), Number(matched2[5]), Number(matched2[6]));
    }
    else {
        time = new Date(2000, 0, 1);
    }
    var timeErr = Number(form['time-err'].value);
    var frm5genIseed = Number(form['frm-5gen-iseed'].value);
    var input = document.getElementById('input').value;
    var freqs = input.split('\n').map(function (x) { return x === '?' ? 0 : parseInt(x, 10); });
    var results = [];
    switch (mode) {
        case '4gen-seed':
            results = searchSeedForGen4(freqs, minFreq);
            break;
        case '4gen-iseed':
            results = searchIseedForGen4(freqs, upper, upperErr, hour, minFrame4genIseed, maxFrame4genIseed, frm4genIseed, minFreq);
            break;
        case '4gen-frm':
            results = searchfrmForGen4(freqs, seed4gen, frm4gen, minFreq);
            break;
        case '5gen-frm':
            results = searchfrmForGen5(freqs, seed5gen, frm5gen, minFreq);
            break;
        case '5gen-iseed':
            results = searchIseedForGen5(freqs, minFreq, nazo1, nazo2, nazo3, nazo4, nazo5, vcount, gxstat, frame, timer0Min, timer0Max, macAddr, time, timeErr, frm5genIseed);
            break;
        default:
    }
    return results;
}
function selectedMode() {
    return document.querySelector('#form input[name="mode"]:checked').value;
}
function setupFormSegments() {
    for (var _i = 0, _a = Array.from(document.querySelectorAll('#form input[name="mode"]')); _i < _a.length; _i++) {
        var radio = _a[_i];
        radio.addEventListener('click', function () {
            update();
        });
    }
    update();
    function update() {
        for (var _i = 0, _a = Array.from(document.querySelectorAll('div.form-segment')); _i < _a.length; _i++) {
            var seg = _a[_i];
            if (seg.id === 'form-segment-' + selectedMode()) {
                seg.style.display = '';
            }
            else {
                seg.style.display = 'none';
            }
        }
    }
}
function setupNowTimeButton() {
    var form = document.getElementById('form');
    var upperInput = form['upper-4gen-iseed'];
    var hourInput = form['hour-4gen-iseed'];
    var button = document.getElementById('now-time-button');
    button.addEventListener('click', function () {
        var date = new Date();
        upperInput.value = '0x' + (((date.getMonth() + 1) * date.getDate() + date.getMinutes() + date.getSeconds()) % 256).toString(16);
        hourInput.value = String(date.getHours());
    });
    var timeInput = form.time;
    var button2 = document.getElementById('now-time-button2');
    button2.addEventListener('click', function () {
        var date = new Date();
        timeInput.value = date.getFullYear() + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* dec */])(date.getMonth() + 1, 2) + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* dec */])(date.getDate(), 2) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* dec */])(date.getHours(), 2) + ':' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* dec */])(date.getMinutes(), 2) + ':' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* dec */])(date.getSeconds(), 2);
    });
}
function save5genParams() {
    var form = document.getElementById('form');
    var obj = {
        nazo1: form.nazo1.value,
        nazo2: form.nazo2.value,
        nazo3: form.nazo3.value,
        nazo4: form.nazo4.value,
        nazo5: form.nazo5.value,
        vcount: form.vcount.value,
        gxstat: form.gxstat.value,
        frame: form.frame.value,
        timer0Min: form['timer0-min'].value,
        timer0Max: form['timer0-max'].value,
        macAddr: form.macaddr.value
    };
    document.getElementById('saved').innerText = 'Saved.';
    window.localStorage.setItem('params', JSON.stringify(obj));
}
function load5genParams() {
    var obj = JSON.parse(window.localStorage.getItem('params') || '{}');
    var form = document.getElementById('form');
    if (obj.nazo1 !== undefined) {
        form.nazo1.value = obj.nazo1;
    }
    if (obj.nazo2 !== undefined) {
        form.nazo2.value = obj.nazo2;
    }
    if (obj.nazo3 !== undefined) {
        form.nazo3.value = obj.nazo3;
    }
    if (obj.nazo4 !== undefined) {
        form.nazo4.value = obj.nazo4;
    }
    if (obj.nazo4 !== undefined) {
        form.nazo5.value = obj.nazo5;
    }
    if (obj.vcount !== undefined) {
        form.vcount.value = obj.vcount;
    }
    if (obj.gxstat !== undefined) {
        form.gxstat.value = obj.gxstat;
    }
    if (obj.frame !== undefined) {
        form.frame.value = obj.frame;
    }
    if (obj.timer0Min !== undefined) {
        form['timer0-min'].value = obj.timer0Min;
    }
    if (obj.timer0Max !== undefined) {
        form['timer0-max'].value = obj.timer0Max;
    }
    if (obj.macAddr !== undefined) {
        form.macaddr.value = obj.macAddr;
    }
}
function searchIseedForGen4(freqs, upper, upperErr, hour, minFrame, maxFrame, maxFrm, minFreq) {
    var results = [];
    for (var u = upper - upperErr; u <= upper + upperErr; u++) {
        for (var frame = minFrame; frame <= maxFrame; frame++) {
            var seed = (((u & 0xff) << 24) + (hour << 16) + frame) >>> 0;
            var lcg = new __WEBPACK_IMPORTED_MODULE_0__lcg__["a" /* LCG */](seed);
            for (var frm = 0; frm < maxFrm; frm++) {
                if (isValidSeed(new __WEBPACK_IMPORTED_MODULE_0__lcg__["a" /* LCG */](lcg.seed), freqs, minFreq)) {
                    results.push(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* hex */])(seed) + ' ' + String(frm));
                }
                lcg.rand();
            }
        }
    }
    return results;
}
function searchSeedForGen4(freqs, minFreq) {
    var results = [];
    for (var seed = 0; seed < 0x20000000; seed++) {
        if (isValidSeed(new __WEBPACK_IMPORTED_MODULE_0__lcg__["a" /* LCG */](seed), freqs, minFreq)) {
            for (var i = 0; i < 8; i++) {
                results.push(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* hex */])(seed + i * 0x20000000));
            }
        }
    }
    return results;
}
function searchfrmForGen4(freqs, seed, maxfrm, minFreq) {
    var results = [];
    var lcg = new __WEBPACK_IMPORTED_MODULE_0__lcg__["a" /* LCG */](seed);
    for (var frm = 0; frm < maxfrm; frm++) {
        if (isValidSeed(new __WEBPACK_IMPORTED_MODULE_0__lcg__["a" /* LCG */](lcg.seed), freqs, minFreq)) {
            results.push(String(frm));
        }
        lcg.rand();
    }
    return results;
}
function searchfrmForGen5(freqs, seed, maxfrm, minFreq) {
    var results = [];
    var lcg = new __WEBPACK_IMPORTED_MODULE_0__lcg__["b" /* Uint64LCG */](seed);
    for (var frm = 0; frm < maxfrm; frm++) {
        if (isValidSeed(new __WEBPACK_IMPORTED_MODULE_0__lcg__["b" /* Uint64LCG */](lcg.seed), freqs, minFreq)) {
            results.push(String(frm));
        }
        lcg.rand();
    }
    return results;
}
function searchIseedForGen5(freqs, minFreq, nazo1, nazo2, nazo3, nazo4, nazo5, vcount, gxstat, frame, timer0Min, timer0Max, macAddr, time, timeErr, maxfrm) {
    var results = [];
    var joypad = 0x2fff;
    var timeBase = time.getTime();
    for (var i = -timeErr; i <= timeErr; i++) {
        var tm = new Date(timeBase + i * 1000);
        for (var timer0 = timer0Min; timer0 <= timer0Max; timer0++) {
            var seed = Object(__WEBPACK_IMPORTED_MODULE_4__gen5_seed__["a" /* gen5_seed */])(nazo1, nazo2, nazo3, nazo4, nazo5, vcount, timer0, gxstat, frame, macAddr, tm, joypad);
            var lcg = new __WEBPACK_IMPORTED_MODULE_0__lcg__["b" /* Uint64LCG */](seed);
            for (var frm = 0; frm < maxfrm; frm++) {
                if (isValidSeed(new __WEBPACK_IMPORTED_MODULE_0__lcg__["b" /* Uint64LCG */](lcg.seed), freqs, minFreq)) {
                    results.push(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* hex */])(seed.high) + Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* hex */])(seed.low) + ' time=' + tm.toLocaleString() + ' timer0=0x' + timer0.toString(16) + ' f=' + frm);
                }
                lcg.rand();
            }
        }
    }
    return results;
}
function isValidSeed(lcg, freqs, minFreq) {
    for (var _i = 0, freqs_1 = freqs; _i < freqs_1.length; _i++) {
        var f = freqs_1[_i];
        var got = (lcg.randMod(8192) * __WEBPACK_IMPORTED_MODULE_1__audio_constant__["a" /* RATIO */] / 8192 + 1) * minFreq;
        if (f !== 0 && Math.abs(f - got) >= 2) {
            return false;
        }
    }
    return true;
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export A */
/* unused harmony export B */
/* unused harmony export AbstractLCG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LCG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Uint64LCG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uint64__ = __webpack_require__(0);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var A = new __WEBPACK_IMPORTED_MODULE_0__uint64__["a" /* Uint64 */](0x5d588b65, 0x6c078965);
var B = new __WEBPACK_IMPORTED_MODULE_0__uint64__["a" /* Uint64 */](0, 0x269ec3);
var AbstractLCG = /** @class */ (function () {
    function AbstractLCG() {
    }
    return AbstractLCG;
}());

var LCG = /** @class */ (function (_super) {
    __extends(LCG, _super);
    function LCG(seed) {
        var _this = _super.call(this) || this;
        _this.seed = seed;
        return _this;
    }
    LCG.prototype.rand = function () {
        this.seed = (Math.imul(this.seed, 0x41c64e6d) + 0x6073) >>> 0;
        return this.seed >>> 16;
    };
    LCG.prototype.randMod = function (n) {
        return this.rand() % n;
    };
    return LCG;
}(AbstractLCG));

var Uint64LCG = /** @class */ (function (_super) {
    __extends(Uint64LCG, _super);
    function Uint64LCG(seed) {
        var _this = _super.call(this) || this;
        _this.seed = new __WEBPACK_IMPORTED_MODULE_0__uint64__["a" /* Uint64 */](seed.high, seed.low);
        return _this;
    }
    Uint64LCG.prototype.rand = function () {
        this.seed.mul(A).add(B);
        return this.seed.high;
    };
    Uint64LCG.prototype.randMod = function (n) {
        var r = this.rand();
        return new __WEBPACK_IMPORTED_MODULE_0__uint64__["a" /* Uint64 */](0, r).mul(new __WEBPACK_IMPORTED_MODULE_0__uint64__["a" /* Uint64 */](0, n)).high;
    };
    return Uint64LCG;
}(AbstractLCG));



/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = parseUint64;
/* harmony export (immutable) */ __webpack_exports__["b"] = hex;
/* harmony export (immutable) */ __webpack_exports__["a"] = dec;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uint64__ = __webpack_require__(0);

function parseUint64(str) {
    return new __WEBPACK_IMPORTED_MODULE_0__uint64__["a" /* Uint64 */](parseInt(str.substr(0, 8), 16), parseInt(str.substr(8, 8), 16));
}
function hex(x) {
    return ('00000000' + x.toString(16)).slice(-8);
}
function dec(x, n) {
    var str = String(x);
    for (var i = n - str.length; i > 0; i--) {
        str = '0' + str;
    }
    return str;
}


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = gen5_seed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uint64__ = __webpack_require__(0);

var K0 = 0x5a827999;
var K1 = 0x6ed9eba1;
var K2 = 0x8f1bbcdc;
var K3 = 0xca62c1d6;
var H0 = 0x67452301;
var H1 = 0xefcdab89;
var H2 = 0x98badcfe;
var H3 = 0x10325476;
var H4 = 0xc3d2e1f0;
function to_u32_little_endian(val) {
    return (((val & 0xff) << 24) | (((val >> 8) & 0xff) << 16) | (((val >> 16) & 0xff) << 8) | ((val >> 24) & 0xff)) >>> 0;
}
function to_bcd(val) {
    return ((val / 10) << 4) | (val % 10);
}
function sha1_circular_shift(bits, word) {
    return ((word << bits) | (word >>> (32 - bits)));
}
function gen5_seed(nazo1, nazo2, nazo3, nazo4, nazo5, vcount, timer0, gxstat, frame, macAddr, time, joypad) {
    var A;
    var B;
    var C;
    var D;
    var E;
    var temp;
    var t;
    var W = Array(80).fill(0);
    var year = time.getFullYear() - 2000;
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var day = time.getDay();
    var hours = time.getHours();
    var minutes = time.getMinutes();
    var seconds = time.getSeconds();
    W[0] = to_u32_little_endian(nazo1);
    W[1] = to_u32_little_endian(nazo2);
    W[2] = to_u32_little_endian(nazo3);
    W[3] = to_u32_little_endian(nazo4);
    W[4] = to_u32_little_endian(nazo5);
    W[5] = to_u32_little_endian((vcount << 16) | timer0);
    W[6] = (macAddr[4] << 8) | macAddr[5];
    W[7] = to_u32_little_endian(gxstat ^ frame ^
        ((macAddr[3] << 24) |
            (macAddr[2] << 16) |
            (macAddr[1] << 8) |
            (macAddr[0])));
    W[8] = (to_bcd(year) << 24) |
        (to_bcd(month) << 16) |
        (to_bcd(date) << 8) |
        day;
    W[9] = ((to_bcd(hours) |
        ((12 <= hours ? 1 : 0) << 6)) << 24) |
        (to_bcd(minutes) << 16) |
        (to_bcd(seconds) << 8);
    W[10] = 0x00000000;
    W[11] = 0x00000000;
    W[12] = to_u32_little_endian(joypad);
    W[13] = 0x80000000;
    W[14] = 0x00000000;
    W[15] = 0x000001A0;
    for (t = 16; t < 80; t++) {
        W[t] = sha1_circular_shift(1, W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16]);
    }
    A = H0;
    B = H1;
    C = H2;
    D = H3;
    E = H4;
    for (t = 0; t < 20; t++) {
        temp = sha1_circular_shift(5, A) + ((B & C) | ((~B) & D)) + E + W[t] + K0;
        E = D;
        D = C;
        C = sha1_circular_shift(30, B);
        B = A;
        A = temp;
    }
    for (t = 20; t < 40; t++) {
        temp = sha1_circular_shift(5, A) + (B ^ C ^ D) + E + W[t] + K1;
        E = D;
        D = C;
        C = sha1_circular_shift(30, B);
        B = A;
        A = temp;
    }
    for (t = 40; t < 60; t++) {
        temp = sha1_circular_shift(5, A) +
            ((B & C) | (B & D) | (C & D)) + E + W[t] + K2;
        E = D;
        D = C;
        C = sha1_circular_shift(30, B);
        B = A;
        A = temp;
    }
    for (t = 60; t < 80; t++) {
        temp = sha1_circular_shift(5, A) + (B ^ C ^ D) + E + W[t] + K3;
        E = D;
        D = C;
        C = sha1_circular_shift(30, B);
        B = A;
        A = temp;
    }
    var seedHigh = to_u32_little_endian(H1 + B) >>> 0;
    var seedLow = to_u32_little_endian(H0 + A) >>> 0;
    return new __WEBPACK_IMPORTED_MODULE_0__uint64__["a" /* Uint64 */](seedHigh, seedLow);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.989a2535.js